import React from 'react';
import PropTypes from 'prop-types';
import { withConditionalFeatures } from '@americanexpress/conditional-features';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Accordion, AccordionContent } from '@americanexpress/dls-react';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import { hasTravelCreditTabRule } from '../../constants/featureRulesConstants';
import TravelCreditTab from './TravelCreditTab';
import TravelCreditTabButton from './TravelCreditTabButton';
import {
  setTravelCreditTabClosed,
  setTravelCreditTabOpen,
} from '../../ducks/homeDuck';
import { getShowTravelCreditTab } from '../../selectors/getHomeSelectors';
import { getTravelCredits } from '../../utils/membershipDataUtils';

const TravelCreditTabButtonWrapper = ({
  hasTravelCreditTab,
  membershipData,
}) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const isMobile = useMediaBreakpoint('sm-down');

  const isTravelCreditTabOpen = useSelector(getShowTravelCreditTab);
  const travelCreditsData = getTravelCredits(membershipData);

  const isTravelCreditUnavailable = !hasTravelCreditTab
    || !travelCreditsData
    || (typeof travelCreditsData === 'object' && Object.keys(travelCreditsData).length === 0)
    || (Array.isArray(travelCreditsData) && travelCreditsData.length === 0);

  if (isTravelCreditUnavailable) {
    return null;
  }

  const buttonLabel = formatMessage({
    id: `travelCreditTab.button.${isTravelCreditTabOpen ? 'close' : 'show'}`,
  });
  const analyticsInfo = {
    element: 'hp-travelCreditTab',
    detail: `${isTravelCreditTabOpen ? 'close' : 'show'}TravelCredit${isMobile ? 'Mobile' : ''}`,
  };

  const onClick = () => {
    if (isTravelCreditTabOpen) {
      return dispatch(setTravelCreditTabClosed);
    }
    return dispatch(setTravelCreditTabOpen);
  };

  if (isMobile) {
    return (
      <Accordion
        openPanelIds={
          isTravelCreditTabOpen ? ['showTravelCreditTabButtonMobile'] : []
        }
      >
        <div className="text-align-center pad-2-b">
          <TravelCreditTabButton
            id="showTravelCreditTabButtonMobile"
            aria-expanded={isTravelCreditTabOpen}
            onClick={onClick}
            buttonLabel={buttonLabel}
            analyticsInfo={analyticsInfo}
          />
        </div>
        <AccordionContent aria-labelledby="showTravelCreditTabButtonMobile">
          <div className="border-tb">
            <TravelCreditTab
              isMobile={true}
              membershipData={membershipData}
            />
          </div>
        </AccordionContent>
      </Accordion>
    );
  }
  return (
    <div className="border-lr text-align-center pad-2-b">
      <TravelCreditTabButton
        id="showTravelCreditTabButton"
        buttonLabel={buttonLabel}
        onClick={onClick}
        analyticsInfo={analyticsInfo}
        aria-expanded={isTravelCreditTabOpen}
      />
    </div>
  );
};

TravelCreditTabButtonWrapper.propTypes = {
  hasTravelCreditTab: PropTypes.bool.isRequired,
  membershipData: PropTypes.shape({
    displayAccountNumber: PropTypes.string,
    cardArtCdnLink: PropTypes.string,
    travelCredits: PropTypes.shape({}),
  }),
};

TravelCreditTabButtonWrapper.defaultProps = {
  membershipData: {},
};

export { TravelCreditTabButtonWrapper as TestableTravelCreditTabButtonWrapper };

export const mapFeaturesToProps = {
  hasTravelCreditTab: hasTravelCreditTabRule,
};

export default withConditionalFeatures({ mapFeaturesToProps })(TravelCreditTabButtonWrapper);
